
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { FaCheck } from "react-icons/fa"
import { FiEdit2 } from "react-icons/fi"
import { HiClock } from "react-icons/hi"
import { RiDeleteBin6Line } from "react-icons/ri"
import { useNavigate } from "react-router-dom"

// import {
//   deleteCourse,
//   fetchInstructorCourses,
// } from "../../../../services/operations/courseDetailsAPI"

import { deleteCourse, fetchInstructorCourses } from "../../operations/courseDetailsAPI"
import { useEffect, useState } from "react"
import { UserAuth } from "../../context/AuthContext"
import ConfirmationModal from "../../components/Common/ConfirmationModel"

export default function InstructorCourses() {
  const navigate = useNavigate()
  const [courses,setCourses]=useState([]);
  const TRUNCATE_LENGTH = 30
  const [confirmationModal, setConfirmationModal] = useState(null)
  const [loading, setLoading] = useState(false)
  const { user } = UserAuth();

  function removeSpace(input) {

    console.log("this is the edired routed:", input.replace(/Course\s+(\d+)/, 'Course$1'))
    return input.replace(/Course\s+(\d+)/, 'Course$1');
}
  const handleCourseDelete = async (courseId) => {
    setLoading(true)
    await deleteCourse(courseId);
    const result = await fetchInstructorCourses(user)
    if (result) {
      setCourses(result)
    }
    setConfirmationModal(null)
    setLoading(false)
  }


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const fetchedCourses = await fetchInstructorCourses(user)
        setCourses(fetchedCourses || []) // Make sure to set it to an empty array if no courses found
      } catch (error) {
        console.error("Error fetching courses: ", error)
      } finally {
        setLoading(false)
      }
    }

    if (user) {
      fetchData()
    }
  }, [user]) // Run effect when the user is available

  if (loading) {
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        <div className="custom-loader"></div>
      </div>
    );
  }

  return (
    <>
      <Table className="rounded-xl border border-richblack-800  mt-10">
        <Thead>
          <Tr className="flex gap-x-10 rounded-t-md border-b border-b-richblack-800 px-6 py-2 text-2xl">
            <Th className="flex-1 text-left  font-medium uppercase text-richblack-100">
              Courses
            </Th>
            <Th className="text-left  font-medium uppercase text-richblack-100">
              Price
            </Th>
            <Th className="text-left font-medium uppercase text-richblack-100">
              Actions
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {!loading && courses?.length === 0 ? (
            <Tr>
              <Td className="py-10 text-center text-2xl font-medium text-richblack-100">
                No courses found
                {/* TODO: Need to change this state */}
              </Td>
            </Tr>
          ) : (
            courses?.map((course) => (
              <Tr
                key={course.CourseId}
                className="flex gap-x-10 border-b border-richblack-800 px-6 py-8"
              >
                <Td className="flex flex-1 gap-x-4 ">
                  <img
                    src={course?.Photo}
                    alt={course?.Name}
                    className="h-[148px] w-[220px] rounded-lg object-cover"
                  />
                  <div className="flex flex-col justify-between p-5">
                    <p className="font-semibold text-richblack-5">
                      {course.Name}
                    </p>
                    <p className="text-[15px] text-richblack-300">
                      {course.Description.split(" ").length >
                      TRUNCATE_LENGTH
                        ? course.Description
                            .split(" ")
                            .slice(0, TRUNCATE_LENGTH)
                            .join(" ") + "..."
                        : course.Description}
                    </p>
                    {!course.Published ? (
                      <p className="flex w-fit flex-row items-center gap-2 rounded-full bg-red-600 px-2 py-[2px] text-[12px] font-medium text-pink-100 mt-3">
                        <HiClock size={14} />
                        Drafted
                      </p>
                    ) : (
                      <p className="flex w-fit flex-row items-center gap-2 rounded-full bg-green-400 px-2 py-[2px] text-[12px] font-medium text-yellow-100 mt-3">
                        <div className="flex h-3 w-3 items-center justify-center rounded-full  bg-green-400 text-richblack-700">
                          <FaCheck size={8} />
                        </div>
                        Published
                      </p>
                    )}
                  </div>
                </Td>
                <Td className=" font-medium text-richblack-100">
                  ₹{course.Price}
                </Td>
                <Td className="text-sm font-medium text-richblack-100 ">
                  <button
                    disabled={loading}
                    onClick={() => {
                      navigate(`/dashboard/edit-course/${removeSpace(course.CourseId)}`)
                    }}
                    title="Edit"
                    className="px-2 transition-all duration-200 hover:scale-110 hover:text-caribbeangreen-300"
                  >
                    <FiEdit2 size={20} />
                  </button>
                  <button
                    disabled={loading}
                    onClick={() => {
                      setConfirmationModal({
                        text1: "Do you want to delete this course?",
                        text2:
                          "All the data related to this course will be deleted",
                        btn1Text: !loading ? "Delete" : "Loading...  ",
                        btn2Text: "Cancel",
                        btn1Handler: !loading
                          ? () => handleCourseDelete(course.CourseId)
                          : () => {},
                        btn2Handler: !loading
                          ? () => setConfirmationModal(null)
                          : () => {},
                      })
                    }}
                    title="Delete"
                    className="px-1 transition-all duration-200 hover:scale-110 hover:text-[#ff0000]"
                  >
                    <RiDeleteBin6Line size={20} />
                  </button>
                </Td>
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
      {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
    </>
  )
}